import { useQuery } from "react-query";
import { QueryKeys } from "./query-client";
import { BACKEND_URL, timezoneOffset } from "../../constants/env";
import { Appointment, Payment } from "../../constants/model/models";
import { useJWT } from "./useJWT";

export interface AppointmentDTO {
  appointment: Appointment;
  payment: Payment | null;
}

export function useAppointmentList() {
  const { jwt } = useJWT();

  async function getAppointmentList(past?: boolean): Promise<AppointmentDTO[]> {
    if (jwt) {
      return fetchAppointments(jwt, past);
    } else {
      return [];
    }
  }

  async function fetchAppointments(authToken: string, past?: boolean) {
    let url = `${BACKEND_URL}/user/appointments?timezoneOffset=${timezoneOffset}&history=false`;
    if (past)
      url = `${BACKEND_URL}/user/appointments?timezoneOffset=${timezoneOffset}&history=true`;

    const response = await fetch(url, {
      headers: {
        "Content-type": "application/json",
        accessToken: authToken,
      },
    });

    return await response.json();
  }

  const {
    data: appointmentData,
    isFetching: appointmentsAreLoading,
    isError: appointmentListError,
  } = useQuery([QueryKeys.APPOINTMENTS], () => getAppointmentList(), {
    keepPreviousData: true,
    enabled: jwt !== null && typeof jwt !== "undefined",
    retry: 2,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  const {
    data: pastAppointmentData,
    isFetching: pastAppointmentsAreLoading,
    isError: pastAppointmentListError,
  } = useQuery([QueryKeys.PAST_APPOINTMENTS], () => getAppointmentList(true), {
    keepPreviousData: true,
    enabled: jwt !== null && typeof jwt !== "undefined",
    retry: 2,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  return {
    appointmentData,
    appointmentsAreLoading,
    appointmentListError,
    pastAppointmentData,
    pastAppointmentListError,
    pastAppointmentsAreLoading,
  };
}
